/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  "'Goals.CreateGoal.footer.create-label": 'Créer',
  'Goals.CreateGoal.create.error': "Impossible de créer l'objectif",
  'Goals.CreateGoal.create.network.error': 'Échec de la connexion',
  'Goals.CreateGoal.create.permission.error': "Vous n'avez pas l'autorisation requise pour créer un objectif.",
  'Goals.CreateGoal.error.description': "Une erreur s'est produite. Vérifiez votre connexion Internet, puis réessayez.",
  'Goals.CreateGoal.error.header': "Impossible de créer l'objectif",
  'Goals.CreateGoal.footer.cancel-label': 'Annuler',
  'Goals.CreateGoal.form.icon.back-button-label': 'Retour',
  'Goals.CreateGoal.form.name.error': "Vous devez indiquer un nom d'objectif",
  'Goals.CreateGoal.form.name.label': 'Nom',
  'Goals.CreateGoal.form.owner.error': 'Le champ « Propriétaire » doit être renseigné.',
  'Goals.CreateGoal.header': 'Créer un objectif',
  'Goals.CreateGoal.parent-goal-label': 'Objectif parent',
  'Goals.CreateGoal.parent-goal.error': 'Le champ « Objectif parent » doit être renseigné.',
  'Goals.CreateGoal.required-fields-are-marked':
    "Les champs obligatoires sont marqués d'un astérisque <asterisk></asterisk>",
  'Goals.CreateGoal.site-label': 'Site',
  'Goals.CreateGoal.type-label': 'Type',
  'Goals.CreateGoal.type-label-placeholder': 'Comment devons-nous appeler cet objectif ?',
  'Goals.GoalCreationModal.label.date-selection-placeholder': 'Sélectionner une date',
  'Goals.GoalCreationModal.label.date-selection-title': 'Date cible',
  'Goals.GoalCreationModal.label.owner-picker-placeholder': "Saisissez le nom d'une personne",
  'Goals.GoalCreationModal.label.owner-selection-title': 'Propriétaire',
  'townsquare.api.goal-type-description.goal': 'Tous les objectifs',
  'townsquare.api.goal-type-description.key-result': 'La méthode quantitative de mesure des objectifs (framework OKR).',
  'townsquare.api.goal-type-description.objective': 'Le résultat que vous souhaitez obtenir (framework OKR).',
};
